import { render, staticRenderFns } from "./AdditionalSalaryModal.vue?vue&type=template&id=03724810&"
import script from "./AdditionalSalaryModal.vue?vue&type=script&lang=ts&"
export * from "./AdditionalSalaryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports